
import heroImage from "../Assests/Images/loginImg.webp";

export const LoginStyles = (theme) => ({
    mainDiv: {
        minHeight: "100vh"
    },

    rootBox: {
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    },

    heading: {
        fontWeight: "bold",
        fontSize: theme.palette.textSize["4xl"],
        textAlign: "center",
        color: theme.palette.text.white,
        pb: 2,
    },

    subHeading: {
        textAlign: "center",
        fontSize: theme.palette.textSize["2xl"],
        color: theme.palette.text.white,
        pb: 2,
    },

    bgDiv: {
        position: "absolute",
        inset: 0,
        bgcolor: "rgba(255,162,0,0.85)",
    },

    tabActive: {
        textTransform: "none",
        fontWeight: "bold",
        color: "black",
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        px: 3,
        width: "50%",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },

    tabInActive: {
        textTransform: "none",
        fontWeight: "normal",
        color: theme.palette.text.black100,
        backgroundColor: "transparent",
        borderRadius: "16px",
        px: 3,
        width: "50%",
        "&:hover": {
            backgroundColor: "rgba(255,255,255,0.2)",
        },
    },

    tabMainDiv: {
        display: "flex",
        backgroundColor: theme.palette.primary.main, // orange background
        borderRadius: 1,
        padding: "4px",
    },

    inputIcon: {
        margin: 8, color: "#aaa"
    },

    submitBtn: {
        mt: 2, p: 3, color: "white", fontWeight: "bold"
    },

    googlebtn: {
        p: 3,
        color: theme.palette.user.grey,
        fontWeight: "bold",
        border: `1px solid #c3cbdaff`,
        borderRadius: 1,
    },

    divider: {
        color: theme.palette.user.grey,
        my: 3,
        fontSize: theme.palette.textSize.sm,
    },

    linksPara: {
        color: theme.palette.user.grey,
        fontSize: theme.palette.textSize.xs,
        textAlign: "center",
        mt: 2,
    },

    welcomeText: {
        color: theme.palette.user.grey,
        fontSize: theme.palette.textSize.md,
        textAlign: "center",
        my: 2,
    },

    anchorLink: {
        color: theme.palette.primary.main,
        textDecoration: "none",
    },

    authDiv: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
    },

    authDiv2: {
        width: "100%",
        textAlign: "center",
        px: { xs: 0, sm: 4 }, // px:0 on mobile, px:4 on desktop and above
    },


    logoImg: {
        width: "100px", height: "100px", objectFit: "contain"
    },

    successToast: {
        background: "#FFFCF0",
        color: "#DC7609",
        border: "1px solid #DC7609",
        position: "relative",
    },

    versionText: {
        color: theme.palette.user.grey,
        fontSize: theme.palette.textSize.xs,
        textAlign: "center",
        mt: 2,
    },

    flex_end: {
        display: "flex",
        justifyContent: "flex-end",
    },

    
})